<template>
  <page>
    <!--
    <v-flex xs12>
      <form>
         <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs6>
                      <v-text-field v-model="filters.polStat" :label="labels.polStat" :error-messages="errors.collect('polStat')" data-vv-name="polStat" :data-vv-as="labels.polStat" data-vv-scope="filters" v-validate="'max:2'"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field v-model="filters.polStatDesc" :label="labels.polStatDesc" :error-messages="errors.collect('polStatDesc')" data-vv-name="polStatDesc" :data-vv-as="labels.polStatDesc" data-vv-scope="filters" v-validate="'max:40'"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    -->
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Policy Status
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <template v-slot:activator="{ on }">
              <v-btn color="secondary" class="white--text" v-on="on">
                <span>Columns</span>
                <v-icon right dark>mdi-table-column-plus-after</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox
                    v-for="column in columns"
                    :key="column.value"
                    :label="column.text"
                    :value="column.value"
                    v-model="selectedColumns"
                  ></v-checkbox>
                </template>
                <template v-else> No column found </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-card-title>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="listHeaders"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td v-for="column in selectedColumns" :key="column">
                    {{ row.item[column] | formatData }}
                  </td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      query
                      @query="doQuery(row.item)"
                      remove
                      @remove="doDelete(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
    <confirm ref="confirmDelete"> Are you sure you want to delete the selected Policy Status? ({{ selectedPolStat }}) </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      labels: {
        polStat: 'Policy Status',
        polStatDesc: 'Description',
        perRen: 'Permit on Renewal',
        perNewRen: 'Permit on New/Renewal',
        perAuto: 'Permit Auto Entry Only',
        ren23yrCvr: 'Renew 2 or 3 Year Cover Period',
        perPol: 'Permit on Policy',
        perQtn: 'Permit on Quotation',
        perCn: 'Permit on Cover Note',
        defRen: 'Default on Renewal',
        autoExtd: 'Auto Extend',
        extBefExp: 'Day to Extend Before Expiry',
        perZeroPrem: 'Permit Zero Premium',
        extdMonDays: 'Extend Month/ Days?',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      filters: {
        polStat: null,
        polStatDesc: null
      },
      columns: [
        { text: 'Policy Status', value: 'polStat' },
        { text: 'Description', value: 'polStatDesc' },
        { text: 'Permit on Renewal', value: 'perRen' },
        { text: 'Permit on New/Renewal', value: 'perNewRen' },
        { text: 'Permit Auto Entry Only', value: 'perAuto' },
        { text: 'Renew 2 or 3 Year Cover Period', value: 'ren23yrCvr' },
        { text: 'Permit on Policy', value: 'perPol' },
        { text: 'Permit on Quotation', value: 'perQtn' },
        { text: 'Permit on Cover Note', value: 'perCn' },
        { text: 'Default on Renewal', value: 'defRen' }
      ],
      selectedColumns: ['polStat', 'polStatDesc'],
      totalItems: 0,
      selectedPolStat: '',
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.menu.getPolStatList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((polStat) => {
                const convertList = {
                  polStat: polStat.polStat,
                  polStatDesc: polStat.polStatDesc,
                  perRen: polStat.perRen,
                  perNewRen: polStat.perNewRen,
                  perAuto: polStat.perAuto,
                  ren23yrCvr: polStat.ren23yrCvr,
                  perPol: polStat.perPol,
                  perQtn: polStat.perQtn,
                  perCn: polStat.perCn,
                  defRen: polStat.defRen
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
      /*
      Filter function
      const apiURI = this.menu.getPolStatList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            const { data } = result.data
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              data.map(polStat => {
                const convertList = {
                  polStat: polStat.polStat,
                  polStatDesc: polStat.polStatDesc,
                  perRen: polStat.perRen,
                  perNewRen: polStat.perNewRen,
                  perAuto: polStat.perAuto,
                  ren23yrCvr: polStat.ren23yrCvr,
                  perPol: polStat.perPol,
                  perQtn: polStat.perQtn,
                  perCn: polStat.perCn,
                  defRen: polStat.defRen
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
      */
    },
    doNew() {
      // this.newPolStat = true
      // this.polStatReview = true
      this.$router.push({
        name: 'polStatDet',
        params: {
          polStat: 'new',
          modePolStat: 'New'
        }
      })
    },
    doReview(data) {
      if (data && data.polStat) {
        this.$router.push({
          name: 'polStatDet',
          params: {
            polStat: data.polStat,
            modePolStat: 'Review'
          }
        })
      }
    },
    doQuery(data) {
      if (data && data.polStat) {
        this.$router.push({
          name: 'polStatDet',
          params: {
            polStat: data.polStat,
            modePolStat: 'Query'
          }
        })
      }
    },
    async doDelete(data) {
      if (data && data.polStat) {
        const apiURI = this.menu.checkDeletePolStat
        const apiURI2 = this.menu.deletePolStat
        const expand = {
          polStat: data.polStat
        }
        if (apiURI && apiURI2) {
          try {
            await this.$http.get(expandURI(apiURI, expand))
            this.selectedPolStat = data.polStat
            const prompt = await this.$refs.confirmDelete.doPopUp()
            if (prompt) {
              const result = await this.$http.delete(expandURI(apiURI2, expand))
              const { data } = result
              this.notify(data)
              this.fetchData(false)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    },
    doFilters() {
      this.$validator.validateAll('filter').then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.polStat = null
      this.filters.polStatDesc = null
      this.fetchData(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.polStatParam.menu
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  filters: {
    formatData(value) {
      if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No'
      }
      return value
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
